class CalculatorSqft extends HTMLElement {
    constructor() {
        super();
        this.handleChangeEvents = this.handleChangeEvents.bind(this);
        this.lastTotalSqFt = null;
    }

    connectedCallback() {
        this.addEventListener('change', this.handleChangeEvents);
    }

    handleChangeEvents(event) {
        const calculatedInputs = Array.from(this.querySelectorAll('.calculated'));
        const directSqFtInput = this.querySelector('#direct-sqft');
        const totalSqFtEl = this.querySelector('#total-sqft');

        const includeWaste = this.querySelector('#include-waste')?.checked ? 1.1 : 1;

        const directSqFt = Number(directSqFtInput?.value);

        let baseSqFt;

        if (directSqFt) {
            calculatedInputs.forEach(input => input.value = null);
            baseSqFt = directSqFt;
        } else {
            const values = calculatedInputs.map(input => Number(input.value));
            const hasMissingValue = values.some(value => !value);

            baseSqFt = hasMissingValue ? 0 : values.reduce((accumulator, value) => accumulator * value, 1);
        }

        const total = baseSqFt * includeWaste;

        totalSqFtEl.innerText = total === 0 ? '--' : `${total.toFixed(2)} sq ft`;

        if (baseSqFt > 0 && total !== this.lastTotalSqFt) {
            this.lastTotalSqFt = total;

            const sqFtChangeEvent = new CustomEvent('sqft:change', {
                detail: {
                    totalSqFt: total
                },
                bubbles: true,
                composed: true
            })
            this.dispatchEvent(sqFtChangeEvent);
        }
    }
}

customElements.define('calculator-sqft', CalculatorSqft);